export enum ForwardAxis {
  X = 'X',
  Z = 'Z'
}
